// extracted by mini-css-extract-plugin
module.exports = {"navigationItem":"navigation-item-module--navigation-item--2wIgA"};